<div class="reminders-list">
    @for (reminder of reminders; track reminder.title) {
        <div class="reminder-row" [ngClass]="reminder.variant || 'warning'">
            <div class="reminder-body">
                <span class="reminder-title">{{ reminder.title }}</span>
                <span class="reminder-text" [innerHTML]="reminder.text"></span>
            </div>
            @if (reminder.actions && reminder.actions.length > 0) {
                <div class="reminder-actions">
                    @for (act of reminder.actions; track act.label) {
                        @if (act.href) {
                            <a [href]="act.href" target="_blank" class="reminder-action-btn">
                                {{ act.label }}
                            </a>
                        } @else {
                            <button class="reminder-action-btn" (click)="act.handler?.()">
                                {{ act.label }}
                            </button>
                        }
                    }
                </div>
            } @else if (reminder.action) {
                @if (reminder.action.href) {
                    <a [href]="reminder.action.href" target="_blank" class="reminder-action-btn">
                        {{ reminder.action.label }}
                    </a>
                } @else {
                    <button class="reminder-action-btn" (click)="reminder.action.handler?.()">
                        {{ reminder.action.label }}
                    </button>
                }
            }
        </div>
    }
    @if (caseProgress === 7 || moneyReceived) {
        <div class="reminder-row status-closed">
            <div class="reminder-body">
                <span class="reminder-title">Case Completed</span>
                <span class="reminder-text">Payment received, all documents processed.</span>
            </div>
            <hugeicons-icon [icon]="checkIcon" [size]="24" color="var(--success-600)"></hugeicons-icon>
        </div>
    }
    @if (offerStatus === 'REJECTED') {
        <div class="reminder-row status-rejected">
            <div class="reminder-body">
                <span class="reminder-title">Offer Rejected</span>
                <span class="reminder-text">Please review and submit a revised offer if needed.</span>
            </div>
            <span class="status-badge rejected">Rejected</span>
        </div>
    }
</div>
